import { Dialog, DialogPanel, DialogTitle, Description } from '@headlessui/react';
import SharedButton from '../Button/Button';
import { SharedDialogProps } from '../../types';

function SharedDialog({
  isOpen,
  onClose,
  title,
  description,
  children,
  onConfirm,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}: SharedDialogProps) {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4 bg-black/50">
        <DialogPanel className="max-w-lg space-y-4 border bg-white p-12 rounded-md shadow-xl">
          <DialogTitle className="font-bold text-xl">{title}</DialogTitle>
          {description && <Description className="text-gray-600">{description}</Description>}
          {children && <div>{children}</div>}
          <div className="flex justify-end gap-4 pt-4">
            <SharedButton onClick={onClose}>{cancelText}</SharedButton>
            {onConfirm && (
              <SharedButton onClick={onConfirm}>
                {confirmText}
              </SharedButton>
            )}
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}

export default SharedDialog;
